import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { C } from '../data/constants.js';

interface SectionHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  color?: string;
}

export function SectionHeader({
  icon: Icon,
  title,
  subtitle,
  actions,
  color,
}: SectionHeaderProps): React.ReactElement {
  const c = color || C.accent;
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
        flexWrap: 'wrap',
        gap: 12,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            background: `linear-gradient(135deg, ${c}22, ${c}0A)`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${c}28`,
          }}
        >
          <Icon size={18} color={c} />
        </div>
        <div>
          <h2
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: '#fff',
              margin: 0,
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            {title}
          </h2>
          {subtitle && (
            <p
              style={{
                fontSize: 12,
                color: C.textDim,
                margin: '2px 0 0',
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {actions && <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>{actions}</div>}
    </div>
  );
}
